require("../javascript/new_ds/config/antibot");
